import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% {
    transform: rotate(0deg)
  }
  10% {
    transform: rotate(90deg)
  }
  20% {
    transform: rotate(570deg)
  }
  30% {
    transform: rotate(270deg)
  }
  40% {
    transform: rotate(90deg)
  }
  50% {
    transform: rotate(0deg)
  }
  60% {
    transform: rotate(15deg)
  }
  70% {
    transform: rotate(-15deg)
  }
  80% {
    transform: rotate(10deg)
  }
  90% {
    transform: rotate(0deg)
  }
  100% {
    transform: rotate(0deg)
  }
`;

const Root = styled.div`
  margin: 1.5rem;
`;

const Logo = styled.svg`
  width: 4.5rem;
`;

const Spinner = styled.g`
  transform-origin: 82px 92px;
  animation: ${spin} 2s linear infinite;
`;

export const LoadingIndicator = ({ size }) => (
  <Root size={size}>
    <Logo size={size} version="1.1" viewBox="0 00 164 185">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-35 -24)">
          <g transform="translate(35 24)">
            <polygon points="0.12644 0.031889 163.13 0.031889 163.13 184.89 0.12644 184.89" />
            <path
              d="m159.28 141.54c2.1173-1.2176 3.8504-4.2069 3.8504-6.6422v-84.874c0-2.4353-1.733-5.4245-3.8504-6.6422l-73.803-42.437c-2.118-1.2183-5.5827-1.2183-7.7007 0l-73.803 42.437c-2.118 1.2176-3.8504 4.2069-3.8504 6.6422v84.874c0 2.4353 1.7324 5.4245 3.8504 6.6422l73.803 42.437c2.118 1.2176 5.5827 1.2176 7.7007 0l73.803-42.437z"
              fill="#4A4A4A"
              fillRule="nonzero"
            />
            <polygon
              points="145.26 128.46 145.26 55.536 81.64 19.073 18.017 55.536 18.017 128.46 81.64 164.93"
              fill="#fff"
              fillRule="nonzero"
            />
            <Spinner fill-rule="nonzero">
              <polygon
                transform="translate(22.521 62.829)"
                points="67.564 43.53 0 61.707 53.504 17.951"
                fill="#E2C044"
              />
              <polygon
                transform="translate(22.521 62.829)"
                points="53.504 17.951 120.49 -3.5527e-15 67.564 43.53"
                fill="#FED766"
              />
            </Spinner>
          </g>
        </g>
      </g>
    </Logo>
  </Root>
);

const SectionBlock = styled.div`
  display: flex;
  justify-content: center;
`;

const LoadingSection = () => (
  <SectionBlock>
    <LoadingIndicator size="large" />
  </SectionBlock>
);

export default LoadingSection;
